import { render, staticRenderFns } from "./AnnouncementPopup.vue?vue&type=template&id=74791eea&scoped=true"
import script from "./AnnouncementPopup.vue?vue&type=script&lang=js"
export * from "./AnnouncementPopup.vue?vue&type=script&lang=js"
import style0 from "./AnnouncementPopup.vue?vue&type=style&index=0&id=74791eea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74791eea",
  null
  
)

export default component.exports